import styled from 'styled-components';

const S = {}

S.AboutSectionWrapper = styled.div`
    max-width: 1200px;
    margin: 0 auto;

    & p {
        margin: 60px 15px;
        line-height: 30px;
        letter-spacing: 0px;
        font-weight: 100;
        font-size: 20px;
        text-align: justify;

        @media (max-width: 768px) {
            font-size: 18px;
        }
    }

    & a {
      text-decoration: none;
      font-weight: 700;
      color: #dc8313f7;
    }
`;

export default S;